import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth41: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.7,376.6l8,26.4,5.5,23.9,2.8,16.9.3,12.4-1.6,5.2-3.6,5.8-5.9,3.7-17.1,1.4-9.4,2-8.5-2.2-14.3-.8-9.2-4.4-4.1-4.6-2.1-3.8-1.3-8.5.6-12.7,1.7-16.5,1.8-11.3,1.7-13,1.9-20.1c30.9-36.9,52.8.2,52.8.2Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M73.9,395.9a8.9,8.9 0 1,1 -17.8,0a8.9,8.9 0 1,1 17.8,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.1,425.2l-9.8-39.7c-35,29.5,9.8,39.7,9.8,39.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.1,427l5.2-41.3c36.4,28.1-5.2,41.3-5.2,41.3Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M87.7,368.6c-23.1-30.4-49.6.5-49.6.5l-1.2,7.3c30.9-36.9,52.8.2,52.8.2l-2-8Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.4,381.1c-25.7,28.4-14.3,92-14.3,92l20-1.4,7.6-7.9,3-8-.4-11.2-3.7-17.6-5.4-26.3-6.8-19.7h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.1,379.9c23.8,15.4,23.3,92.6,23.3,92.6l-14.6-.5-9.8-4.6-5.7-8-.8-6.8-.4-15.7.5-5.2,3.1-19.3,2.2-16.9,2.2-15.5h0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '106.5 456.2 101.5 466.7 95.6 471.2 68.9 474.3 46.7 471.9 36.7 467.9 30.8 459.5 29.4 452.8 29.2 446.2 106.5 446.2 106.5 456.2',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.7,376.6l8,26.4,5.5,23.9,2.8,16.9.3,12.4-1.6,5.2-3.6,5.8-5.9,3.7-17.1,1.4-9.4,2-8.5-2.2-14.3-.8-9.2-4.4-4.1-4.6-2.1-3.8-1.3-8.5.6-12.7,1.7-16.5,1.8-11.3,1.7-13,1.9-20.1c30.9-36.9,52.8.2,52.8.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'31.2 432.4 38.5 421.2 42.2 436.9 47.1 417.8 53.5 437.3 59.4 417.8 66 437.1 72.1 417.8 78.7 438.4 84.2 418.7 91.2 438.4 93.5 421.9 102.6 432',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'62.7 359 67.8 353.9 61.9 348 67.1 342.8 61.6 337.3 66.5 332.4 61.6 327.5 66.4 322.8 60.7 317.1 65.3 312.5 60.9 308 65.5 303.4 60.6 298.5 65.5 293.6 60.9 289 65.8 284.1 61.4 279.7 66.3 274.9 61 269.7 66.7 264 61.6 259 67.1 253.4 61.9 248.2 67.4 242.8 61.4 236.8 66.5 231.8 60.9 226.2 66.9 220.3 61.7 215.1 67.1 209.7 61.5 204.1 67.2 198.4 61.8 193 67.1 187.7 61.4 182 66.7 176.6 61.1 171 66.4 165.7 60.6 153.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'46.5 264.2 48.5 259.6 50.8 264.4 53.2 260 56.1 264.1 59.6 259.3 62.7 265 66.5 259.6 70.2 265 73.3 260 76.6 264.9',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '92.6 84 96.7 84.4 101.4 86.4 103.8 88.1 106.3 92.2 106 97.4 103.8 101.8 101.3 106.3 98.8 109.3 95.1 112.9 93.8 114.2 87 119.9 84.6 123.8 72.5 133 67.1 135.2 63 135.6 52.3 135.7 46.5 132.6 39.1 127.3 36.1 122.8 32.8 118.4 28.9 113.7 25.8 111.4 24.2 108.4 22.7 106.2 21.7 102.5 21.7 99.8 22.2 95.2 23.3 93.1 25.6 90.2 31.1 88.1 32.9 86.2 39.8 75.9 46.2 68.4 51.9 63.9 58.5 60.5 64.1 60.2 68.3 61.3 72.1 62.9 76.6 67.2 87.8 83.5 92.6 84',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.9,114.9h39.2c-20.7,16.1-39.2,0-39.2,0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M96.1,84.5c-24.7,11.5-.5,28.2-.5,28.2l2-1.3,2-2.2,2.8-3.4,2.3-3.4,1.3-4v-6s-.7-2-.7-2l-2.4-3.5-3.3-2.1-3.5-.5v.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.5,112.3l-4.4-5.6s-1.3-4.3-1.4-4.3v-3.8s1.3-4.4,1.3-4.4l2-2.8,3.6-2.6,4.6-3.1c26.7,15.8-5.7,26.6-5.7,26.6Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '99.6 84.7 102.8 86.8 105.3 90.3 106 92.3 106 98.3 104.7 102.3 102.4 105.6 99.6 109 97.6 111.2 95.6 112.5 26.5 112.3 22.1 106.7 20.8 102.4 20.7 98.6 22 94.1 23.9 91.4 29 87.7 33.8 84.5 96.1 84.3 99.6 84.7',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M96.7,84.4l4.7,2,2.4,1.7,2.5,4.1-.3,5.2-2.2,4.4c-54.9,10.4-82.1.7-82.1.7l.5-7.3,3.4-5,5.5-2.1,1.8-1.9,6.9-10.3,6.4-7.5,5.7-4.5,6.6-3.4,5.6-.3,8,2.7,4.5,4.3,11.2,16.3s8.9.9,8.9.9Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.7,102.5l1,3.7,1.5,2.2,1.6,3,3.1,2.3,3.9,4.7,3.3,4.4,3,4.5,7.4,5.3,5.8,3h10.7s4.1-.4,4.1-.4l5.4-2.2,12.1-9.2,2.4-3.9,8.1-7,3.7-3.6,2.5-3,2.5-4.5c-54.3,10.4-82.1.7-82.1.7',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'23.2 96.4 31.6 109.3 35.8 91.4 41.5 113.3 48.7 90.8 55.5 113.3 63 91.1 70 113.3 77.6 89.7 83.8 112.1 91.9 89.7 94.4 108.5 104.8 97',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.1,149.4l-1.5-8.8-3.6-14.2-7.3-53.6-.4-12.4,2-9.5,5.5-12,6.9-3.3,22.1.8,9-2,11.3,5.5h11.6s13.2,7.5,13.2,7.5l3.5,6.6,1.9,9.9-.2,11.3-4.8,22.1-10.5,44.5-1.9,7.1c-29.1,59.9-56.8.5-56.8.5Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.3,114.2h49c-28.1,100.6-49,0-49,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M96.2,122.6l10-42.9c-53.5,4.5-10,42.9-10,42.9Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.9,118.4l-4.8-44.2c54.1,14.2,4.8,44.2,4.8,44.2Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.9,148.9l-.7,11.9c-27.7,48.7-54.3,1.9-54.3,1.9l-1.8-13.3c31.7,59,56.8-.5,56.8-.5h0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '20.5 71.5 20.5 66.9 20.5 57.2 22.8 48.1 26.5 40.4 33.7 34.7 64.9 34.7 77.5 39.7 90.7 40.2 102.9 48.6 107 58.2 107.4 72.1 20.5 71.5',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M91.7,140.9c-24.2-31-16.1-102.2-16.1-102.2l4.8.9,10.6.9,11.7,7.6,4.2,10.4.4,15-1.2,7.2-4.8,21.2-4.2,16.4-5.3,22.6h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M55.6,35.7s-1.4,85.5-24.4,105.6l-3.9-15-3.7-29.3-3.2-26v-10.9s.4-5.8.4-5.8l4.1-10.1,3.7-6,5.3-2.8,21.7.4h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.1,149.4l-1.5-8.8-3.6-14.2-7.3-53.6-.4-12.4,2-9.5,5.5-12,6.9-3.3,22.1.8,9-2,11.3,5.5h11.6s13.2,7.5,13.2,7.5l3.5,6.6,1.9,9.9-.2,11.3-4.8,22.1-10.5,44.5-1.9,7.1c-29.1,59.9-56.8.5-56.8.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'24.9 101.9 32.8 113.9 36.6 97.3 41.8 117.5 48.6 96.7 54.8 117.5 61.9 97 68.3 117.5 75.3 95.7 81 116.5 88.6 95.7 90.8 113.1 100.5 102.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'62 170.4 56.7 175.2 62.4 181.4 57 186.3 62.2 192 57.1 196.7 61.8 201.9 56.8 206.4 62.2 212.3 57.4 216.7 61.7 221.4 56.9 225.8 61.6 230.9 56.5 235.6 60.9 240.4 55.8 245.1 59.9 249.6 54.9 254.2 59.9 259.7 54 265.1 58.9 270.3 53.1 275.6 58.1 281.1 52.4 286.3 58.1 292.5 52.8 297.3 58.1 303.1 51.9 308.8 56.9 314.2 51.3 319.4 56.6 325.1 50.6 330.6 55.9 336.3 50.3 341.3 55.8 347.3 50.2 352.4 55.6 358.3 50.1 363.4 55.3 375.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'39.3 273.7 41.6 279.2 44.4 273.4 47.2 278.6 50.6 273.9 54.7 279.5 58.4 272.8 62.9 279.2 67.3 272.8 71 278.6 74.8 272.9',
			],
		},
	},
};
